module.exports = __webpack_public_path__ + "img/icon8.741b63a5.png";